export default __webpack_public_path__ + "static/media/kitchen4-afterB-480w.1071dfbe.png";